<!-- Modal -->
<ng-template #content role="document" let-modal>
    <div class="modal-header p-3 ps-4 bg-soft-primary">
        <h5 class="modal-title" id="inviteMembersModalLabel">
            {{'t-proposals.t-new-proposal' | translate}}
        </h5>
        <button type="button" id="proposal-dismiss-btn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    
    <div class="modal-body p-4">
        <div *ngIf="isInternalShareProposal" class="alert alert-info d-flex align-items-center" role="alert">
            <i class="ri-share-forward-line me-2"></i>
            {{'t-proposal-form.t-internal-share-info' | translate}}
        </div>
        <div *ngIf="!proposalType" class="row mb-4">
            <div class="col-md-12">
                <label class="form-label w-100">{{'t-proposal-form.t-proposal-type' | translate}}:</label>

                <div *ngIf="entityData?.id !== 82 || isEdit" class="form-check form-check-inline mb-2 w-100">
                    <input type="radio" class="form-check-input" id="typeResume" name="proposalType" [value]="'resume'"
                        [(ngModel)]="proposalType" (change)="changeProposalType()">
                    <label class="form-check-label" for="typeResume">
                        {{'t-proposal-form.t-resumed-proposal' | translate}} <span
                            class="badge badge-soft-primary ms-1 rounded-pill"
                            ngbTooltip="{{'t-proposal-form.t-resumed-proposal-tooltip' | translate}}" placement="top">
                            ?
                        </span>
                    </label>
                </div>

                <div class="form-check form-check-inline w-100">
                    <input type="radio" class="form-check-input" id="typeFull" name="proposalType" [value]="'full'"
                        [(ngModel)]="proposalType" (change)="changeProposalType()">

                    <label class="form-check-label" for="typeFull">
                        {{'t-proposal-form.t-full-proposal' | translate}} 
                        <span
                            class="badge badge-soft-primary ms-1 rounded-pill"
                            ngbTooltip="{{'t-proposal-form.t-full-proposal-tooltip' | translate}}" placement="top">
                            ?
                        </span>
                    </label>
                </div>
            </div>
        </div>

        <div *ngIf="proposalType === 'full'">
            <div class="mb-4">
                <ul class="nav nav-pills">
                    <li class="nav-item" *ngFor="let step of steps; let i = index">
                        <a class="nav-link" [class.active]="currentStep === i">{{ step | translate }}</a>
                    </li>
                </ul>
            </div>

            <form [formGroup]="fullProposalForm">
                <!-- STEP 1: Identificação -->
                <div *ngIf="currentStep === 0">
                    <h5>{{ 't-proposal-form-proposers' | translate }}</h5>
                    <div class="row">
                        <!-- Card para cada proponente -->
                        <div class="col-md-6 mb-3" *ngFor="let proposer of proposers; let i = index">
                            <div class="card mb-0 shadow-sm">
                                <div class="card-body">
                                    <h6 class="card-title mb-1">
                                        {{ proposer?.company || proposer.name }}
                                    </h6>
                                    <p class="mb-0 small text-muted">{{ 't-proposal-form-nif' | translate }}: {{ proposer.fiscalIdentification ||
                                        proposer?.companyFiscalIdentification }}</p>
                                    <p class="mb-0 small text-muted">{{ 't-proposal-form-type' | translate }}: {{ proposerTypeKey(proposer.type) | translate }}</p>
                                    <div class="align-items-center d-flex gap-2 mt-2">
                                        <button (click)="openProposerForm(modalProposer, proposer)"
                                            class="btn btn-sm btn-outline-primary">
                                            <i class="ri-edit-line"></i> {{'t-edit' | translate}}
                                        </button>
                                        <button (click)="removeProposer(proposer)"
                                            class="btn btn-sm btn-outline-danger">
                                            <i class="ri-delete-bin-line"></i> {{'t-delete' | translate}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Card "Adicionar novo" -->
                        <div class="col-md-6 mb-3">
                            <div class="card h-100 border-dashed d-flex justify-content-center align-items-center"
                                style="cursor: pointer;" (click)="openProposerForm(modalProposer, null)">
                                <div class="card-body text-center">
                                    <i class="ri-user-add-line fs-3 text-primary"></i>
                                    <p class="mb-0 text-primary">{{ 't-proposal-form-add-proposer' | translate }}</p>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showError" class="col-12">
                            <span *ngIf="showError['proposers']" class="text-danger">{{ 't-proposal-form-error-proposers' | translate }}</span>
                            <span *ngIf="showError['beneficial']" class="text-danger">{{ 't-proposal-form-error-beneficial' | translate }}</span>
                        </div>
                    </div>
                </div>

                <!-- STEP 2: Proposta -->
                <div *ngIf="currentStep === 1">
                    <h5>{{ 't-proposal-form-step-proposal' | translate }}</h5>
                    <div>
                        <div class="row" *ngIf="isSaleBusinessType">
                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-value' | translate }}</label>
                                <input type="text"
                                    [ngClass]="{ 'is-invalid': proposalFormControls['proposalValue'].errors }"
                                    mask="separator" thousandSeparator=" " class="form-control"
                                    formControlName="proposalValue" />
                                <div *ngIf="proposalFormControls['proposalValue'].errors" class="invalid-feedback">
                                    <span *ngIf="proposalFormControls['proposalValue'].errors">{{ 't-proposal-form-value-required' | translate }}</span>
                                </div>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-bank' | translate }}</label>
                                <input class="form-control" formControlName="bank" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-financing' | translate }}</label>
                                <input type="text" class="form-control" formControlName="financing" mask="separator"
                                    thousandSeparator=" " suffix="%">
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-funds-source' | translate }}</label>
                                <input class="form-control" formControlName="sourceFunds" />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-cpcv-deadline' | translate }}</label>
                                <input class="form-control" type="number" formControlName="promiseContractTime" />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-signal' | translate }}</label>
                                <div class="input-group">
                                    <input mask="separator" thousandSeparator=" " class="form-control"
                                        formControlName="signalBooster" />
                                    <select class="form-select flex-grow-0" style="width: 80px"
                                        formControlName="signalBoosterPercent">
                                        <option [ngValue]="false">€</option>
                                        <option [ngValue]="true">%</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-signal-2' | translate }}</label>
                                <div class="input-group">
                                    <input mask="separator" thousandSeparator=" " class="form-control"
                                        formControlName="signalBooster2" />
                                    <select class="form-select flex-grow-0" style="width: 80px"
                                        formControlName="signalBooster2Percent">
                                        <option [ngValue]="false">€</option>
                                        <option [ngValue]="true">%</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-signal-3' | translate }}</label>
                                <div class="input-group">
                                    <input mask="separator" thousandSeparator=" " class="form-control"
                                        formControlName="signalBooster3" />
                                    <select class="form-select flex-grow-0" style="width: 80px"
                                        formControlName="signalBooster3Percent">
                                        <option [ngValue]="false">€</option>
                                        <option [ngValue]="true">%</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-signal-4' | translate }}</label>
                                <div class="input-group">
                                    <input mask="separator" thousandSeparator=" " class="form-control"
                                        formControlName="signalBooster4" />
                                    <select class="form-select flex-grow-0" style="width: 80px"
                                        formControlName="signalBooster4Percent">
                                        <option [ngValue]="false">€</option>
                                        <option [ngValue]="true">%</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-deed-deadline' | translate }}</label>
                                <input class="form-control" type="number" formControlName="deedTime" />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-purpose' | translate }}</label>
                                <ng-select [ngClass]="{ 'is-invalid': proposalFormControls['purpose'].errors }"
                                    [clearable]="false" formControlName="purpose">
                                    <ng-option value="PERMANENT">{{ 't-proposal-form-purpose-permanent' | translate }}</ng-option>
                                    <ng-option value="SECONDARY">{{ 't-proposal-form-purpose-secondary' | translate }}</ng-option>
                                    <ng-option value="INVESTMENT">{{ 't-proposal-form-purpose-investment' | translate }}</ng-option>
                                </ng-select>
                                <div *ngIf="proposalFormControls['purpose'].errors" class="invalid-feedback">
                                    <span *ngIf="proposalFormControls['purpose'].errors">{{ 't-proposal-form-purpose-required' | translate }}</span>
                                </div>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-reservation' | translate }}</label>
                                <input class="form-control" formControlName="reserveValue" />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-payment-method' | translate }}</label>
                                <ng-select formControlName="paymentMethod">
                                    <ng-option value="CASH">{{ 't-proposal-form-payment-cash' | translate }}</ng-option>
                                    <ng-option value="CHECK_REAL">{{ 't-proposal-form-payment-check-real' | translate }}</ng-option>
                                    <ng-option value="CHECK_OWNER">{{ 't-proposal-form-payment-check-owner' | translate }}</ng-option>
                                    <ng-option value="TRANSFER_REAL">{{ 't-proposal-form-payment-transfer-real' | translate }}</ng-option>
                                    <ng-option value="TRANSFER_OWNER">{{ 't-proposal-form-payment-transfer-owner' | translate }}</ng-option>
                                </ng-select>
                            </div>

                        </div>

                        <div class="row" *ngIf="isRentBusinessType">
                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-rent-value' | translate }}</label>
                                <input type="text"
                                    [ngClass]="{ 'is-invalid': proposalFormControls['proposalValue'].errors }"
                                    mask="separator" thousandSeparator=" " class="form-control"
                                    formControlName="proposalValue" />
                                <div *ngIf="proposalFormControls['proposalValue'].errors" class="invalid-feedback">
                                    <span *ngIf="proposalFormControls['proposalValue'].errors">{{ 't-proposal-form-rent-value-required' | translate }}</span>
                                </div>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-rent-start' | translate }}</label>
                                <input class="form-control" type="date" formControlName="startDate" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-rent-deposit' | translate }}</label>
                                <input class="form-control" formControlName="securityDeposit" />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-rent-duration' | translate }}</label>
                                <input class="form-control" type="number" formControlName="contractDuration" />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-rent-renewal' | translate }}</label>
                                <input class="form-control" type="number" formControlName="renewalDuration" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-rent-purpose' | translate }}</label>
                                <ng-select [ngClass]="{ 'is-invalid': proposalFormControls['purpose'].errors }"
                                    [clearable]="false" formControlName="purpose">
                                    <ng-option value="PERMANENT">{{ 't-proposal-form-purpose-permanent' | translate }}</ng-option>
                                    <ng-option value="SECONDARY">{{ 't-proposal-form-purpose-secondary' | translate }}</ng-option>
                                    <ng-option value="INVESTMENT">{{ 't-proposal-form-purpose-investment' | translate }}</ng-option>
                                </ng-select>
                                <div *ngIf="proposalFormControls['purpose'].errors" class="invalid-feedback">
                                    <span *ngIf="proposalFormControls['purpose'].errors">{{ 't-proposal-form-purpose-required' | translate }}</span>
                                </div>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-reservation' | translate }}</label>
                                <input class="form-control" formControlName="reserveValue" />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>{{ 't-proposal-form-payment-method' | translate }}</label>
                                <ng-select formControlName="paymentMethod">
                                    <ng-option value="CASH">{{ 't-proposal-form-payment-cash' | translate }}</ng-option>
                                    <ng-option value="CHECK_REAL">{{ 't-proposal-form-payment-check-real' | translate }}</ng-option>
                                    <ng-option value="CHECK_OWNER">{{ 't-proposal-form-payment-check-owner' | translate }}</ng-option>
                                    <ng-option value="TRANSFER_REAL">{{ 't-proposal-form-payment-transfer-real' | translate }}</ng-option>
                                    <ng-option value="TRANSFER_OWNER">{{ 't-proposal-form-payment-transfer-owner' | translate }}</ng-option>
                                </ng-select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <label class="form-label">{{'t-proposals.t-observations' | translate}}</label>
                                <textarea class="form-control" formControlName="obs" rows="3"
                                    placeholder="{{'t-proposals.t-observations' | translate}}"></textarea>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- STEP 3: Mediação -->
                <div *ngIf="currentStep === 2">
                    <h5>{{ 't-proposal-form-step-mediation' | translate }}</h5>
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label>{{ 't-proposal-form-store' | translate }}</label>
                            <input type="text" class="form-control" formControlName="mediationStore">
                        </div>
                        <div class="col-md-6 mb-3">
                            <label>{{ 't-proposal-form-responsible' | translate }}</label>
                            <input type="text" class="form-control" formControlName="responsible">
                        </div>
                    </div>
                </div>

                <!-- Botões de navegação -->
                <div class="d-flex justify-content-between mt-4">
                    <button type="button" class="btn btn-outline-danger" [attr.disabled]="spinnerLoading ? true : null"
                        (click)="previousStep()" [disabled]="currentStep === 0">{{ 't-proposal-form-previous' | translate }}</button>
                    <button type="button" class="btn btn-primary" (click)="nextStep()"
                        *ngIf="currentStep < steps.length - 1">{{ 't-proposal-form-next' | translate }}</button>
                    <button *ngIf="currentStep === steps.length - 1" [attr.disabled]="spinnerLoading ? true : null"
                        class="btn btn-success" (click)="generateProposal()"><span *ngIf="spinnerLoading"
                            class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>{{ 't-proposal-form-generate' | translate }}</button>
                </div>
            </form>
        </div>

        <form *ngIf="proposalType === 'resume' && (entityData?.id !== 82 || isEdit)" [formGroup]="proposalForm">
            <div class="row">
                <div class="col-md-12 mb-3">
                    <label for="inventoryValueInput" class="form-label">
                        {{'t-proposals.t-buyer-type' | translate}}:
                    </label>
                    <div class="form-check mb-1">
                        <input (change)="changeType(false)" class="form-check-input" [value]="false" type="radio"
                            name="agencyProposal" id="flexRadioDefault1" formControlName="agencyProposal">
                        <label class="form-check-label" for="flexRadioDefault1">
                            {{'t-proposals.t-private' | translate}}
                        </label>
                    </div>
                    <div class="form-check">
                        <input (change)="changeType(true)" class="form-check-input" [value]="true" type="radio"
                            name="agencyProposal" id="flexRadioDefault2" formControlName="agencyProposal">
                        <label class="form-check-label" for="flexRadioDefault2">
                            {{'t-proposals.t-agency' | translate}}
                        </label>
                    </div>
                </div>
                <div *ngIf="form['agencyProposal'].value" class="col-md-7 mb-3">
                    <label class="form-label">{{'t-partner-entity' | translate}}</label>
                    <input type="text" class="form-control"
                        [ngClass]="{ 'is-invalid': submited && form['partnerName'].errors }"
                        placeholder="{{'t-partner-entity' | translate}}" formControlName="partnerName">
                    <div *ngIf="submited && form['partnerName'].errors" class="invalid-feedback" align="left">
                        {{ 't-name-error-required' | translate }}
                    </div>
                </div>
                <div *ngIf="form['agencyProposal'].value" class="col-md-5 mb-3">
                    <label class="form-label">{{'t-license' | translate}}</label>
                    <input class="form-control" placeholder="{{'t-license' | translate}}"
                        [ngClass]="{ 'is-invalid': submited && form['licenseImo'].errors }" formControlName="licenseImo"
                        formControlName="licenseImo" type="text">
                    <div *ngIf="submited && form['licenseImo'].errors" class="invalid-feedback" align="left">
                        <div *ngIf="form['licenseImo'].errors['required']">
                            {{ 't-license-error-required' | translate }}
                        </div>
                    </div>
                </div>
                <div *ngIf="form['agencyProposal'].value" class="col-md-12 mb-3">
                    <label class="form-label">
                        {{'t-proposals.t-share-commission' | translate}}
                    </label>
                    <div class="values d-flex justify-content-between align-items-center mb-1">
                        <span class="fw-bold">{{'t-proposals.t-my-agency' | translate}}: <span
                                class="fw-normal">{{form['saleDivision'].value}}%</span></span>
                        <span class="fw-bold">{{'t-proposals.t-partner' | translate}}: <span class="fw-normal">{{100 -
                                form['saleDivision'].value}}%</span></span>
                    </div>
                    <input type="range" min="0" max="100" formControlName="saleDivision" class="form-range"
                        id="customRange1">
                </div>
                <div *ngIf="!form['agencyProposal'].value && isInternalShareProposal" class="col-md-12 mb-3">
                    <div *ngIf="internalShareStoreOptions.length > 1" class="mb-3">
                        <label class="form-label">{{'t-internal-share-store' | translate}}</label>
                        <ng-select [items]="internalShareStoreOptions" bindValue="id" bindLabel="name"
                            [clearable]="true" placeholder="{{'t-internal-share-select-store' | translate}}"
                            [(ngModel)]="internalSharePartnerStoreId" [ngModelOptions]="{ standalone: true }">
                        </ng-select>
                    </div>
                    <label class="form-label">
                        {{'t-proposals.t-share-commission' | translate}}
                    </label>
                    <div class="values d-flex justify-content-between align-items-center mb-1">
                        <span class="fw-bold">{{'t-proposals.t-partner' | translate}}: <span
                                class="fw-normal">{{form['saleDivision'].value}}%</span></span>
                        <span class="fw-bold">{{'t-proposals.t-my-agency' | translate}}: <span class="fw-normal">{{100 -
                                form['saleDivision'].value}}%</span></span>
                    </div>
                    <input type="range" min="0" max="100" formControlName="saleDivision" class="form-range"
                        id="internalShareDivisionRange">
                </div>
                <div class="col-md-6 mb-3">
                    <label class="form-label">{{'t-proposals.t-proposal-value' | translate}}</label>
                    <input type="text" class="form-control"
                        [ngClass]="{ 'is-invalid': submited && form['value'].errors }" mask="separator"
                        thousandSeparator=" " id="priceInput"
                        placeholder="{{'t-proposals.t-proposal-value' | translate}}" formControlName="value">
                    <div *ngIf="submited && form['value'].errors" class="invalid-feedback" align="left">
                        {{'t-proposals.t-proposal-value-mandatory' | translate}}
                    </div>
                </div>
                <div class="col-md-6 mb-3">
                    <label class="form-label">{{'t-proposals.t-proposal-date' | translate}} </label>
                    <input class="form-control flatpickr-input"
                        [ngClass]="{ 'is-invalid': submited && form['proposalDate'].errors }" type="text"
                        placeholder="{{ 't-general.t-select' | translate }}" mwlFlatpickr [convertModelValue]="true"
                        [dateFormat]="'Y-m-d'" formControlName="proposalDate" />
                </div>
                <div class="col-12 mb-3">
                    <label class="form-label">{{'t-proposals.t-observations' | translate}}</label>
                    <textarea class="form-control" formControlName="obs" rows="3"
                        placeholder="{{'t-proposals.t-observations' | translate}}"></textarea>
                </div>
                <div class="col-md-6">
                    <label class="form-label mb-0">{{'t-proposals.t-file-input' | translate}}</label>
                    <div class="d-flex align-items-center py-2 rounded">
                        <input hidden accept=".jpeg, .jpg, .png, .pdf, .doc, .docx" class="form-control" type="file" id="input-filec"
                            (change)="onFileChange($event)">
                        <a *ngIf="!form['file'].value" href="javascript:void(0);"
                            class="btn btn-outline-primary btn-label waves-effect waves-light btn-sm"
                            (click)="addFileCostumer()">
                            <div class="d-flex">
                                <div class="flex-shrink-0">
                                    <i class="ri-file-upload-line label-icon align-middle fs-16 me-2"></i>
                                </div>
                                <div class="flex-grow-1">
                                    {{'t-upload-file' | translate}}
                                </div>
                            </div>
                        </a>
                        <div class="d-flex align-items-center border border-dashed p-2 rounded"
                            *ngIf="form['file']?.value">
                            <div class="flex-shrink-0 avatar-sm">
                                <div class="avatar-title bg-light rounded">
                                    <i class="ri-file-zip-line fs-20 text-primary"></i>
                                </div>
                            </div>
                            <div class="flex-grow-1 ms-3">
                                <h6 class="mb-1"><a href="javascript:void(0);">{{form['file'].value?.name}}</a>
                                </h6>
                                <small class="text-muted">{{formatSizeUnits(form['file'].value?.size)}}</small>
                            </div>
                            <div class="hstack gap-3 ms-3 fs-16">
                                <a href="javascript:void(0);" class="text-muted" (click)="deleteFile()"><i
                                        class="ri-delete-bin-line"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div *ngIf="proposalType === 'resume' && (entityData?.id !== 82 || isEdit)" class="modal-footer">
        <button type="button" class="btn btn-light w-xs" data-bs-dismiss="modal"
            (click)="clearForm(); modal.close('')">{{'t-proposals.t-cancel' | translate}}</button>
        <button type="button" class="btn btn-primary w-xs" (click)="submitNewProposal()">
            {{'t-proposals.t-submit-proposal' | translate}}
        </button>
    </div>
    <!-- <app-proposal-template></app-proposal-template> -->
</ng-template>

<ng-template #modalProposer let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Dados do Proponente</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <form [formGroup]="proposerForm">
        <div class="modal-body">
            <div class="accordion" id="proposerAccordion">

                <!-- Proposer Type -->
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingType">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseType" aria-expanded="true" aria-controls="collapseType">{{ 't-proposal-form-proposer-type' | translate }}</button>
                    </h2>
                    <div id="collapseType" class="accordion-collapse collapse show" aria-labelledby="headingType"
                        data-bs-parent="#proposerAccordion">
                        <div class="accordion-body">
                            <label for="typeSelect">{{ 't-proposal-form-proposer-type' | translate }}</label>
                            <ng-select id="typeSelect" [clearable]="false" formControlName="type"
                                (change)="onTypeChange()">
                                <ng-option value="INDIVIDUAL">{{ 't-proposal-form-proposer-individual' | translate }}</ng-option>
                                <ng-option value="LEGAL">{{ 't-proposal-form-proposer-legal' | translate }}</ng-option>
                                <ng-option value="EFFECTIVE_BENEFICIARY">{{ 't-proposal-form-proposer-beneficiary' | translate }}</ng-option>
                                <ng-option *ngIf="isRentBusinessType"
                                    value="FIATHER">{{ 't-proposal-form-proposer-guarantor' | translate }}</ng-option>
                            </ng-select>
                        </div>
                    </div>
                </div>

                <!-- Pessoa Singular -->
                <div class="accordion-item" *ngIf="isSingular()">
                    <h2 class="accordion-header" id="headingSingular">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseSingular" aria-expanded="false" aria-controls="collapseSingular">
                            Identificação
                        </button>
                    </h2>
                    <div id="collapseSingular" class="accordion-collapse collapse" aria-labelledby="headingSingular"
                        data-bs-parent="#proposerAccordion">
                        <div class="accordion-body">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label for="nameInput">Nome</label>
                                    <input [ngClass]="{ 'is-invalid': proposerFormControls['name'].errors }"
                                        id="nameInput" class="form-control" formControlName="name" />
                                    <div *ngIf="proposerFormControls['name'].errors" class="invalid-feedback">
                                        <span *ngIf="proposerFormControls['name'].errors">O Nome é obrigatório</span>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="nifInput">NIF</label>
                                    <input id="nifInput"
                                        [ngClass]="{ 'is-invalid': proposerFormControls['fiscalIdentification'].errors }"
                                        class="form-control" formControlName="fiscalIdentification" />
                                    <div *ngIf="proposerFormControls['fiscalIdentification'].errors"
                                        class="invalid-feedback">
                                        <span *ngIf="proposerFormControls['fiscalIdentification'].errors">O NIF é
                                            obrigatório</span>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label for="docTypeSelect">Tipo de Documento</label>
                                    <ng-select [ngClass]="{ 'is-invalid': proposerFormControls['docType'].errors }"
                                        id="docTypeSelect" [clearable]="false" formControlName="docType">
                                        <ng-option value="CITIZEN_CARD">Cartão Cidadão</ng-option>
                                        <ng-option value="ID_CARD">Bilhete de Identidade</ng-option>
                                        <ng-option value="RESIDENCE">Título de Residência</ng-option>
                                        <ng-option value="PASSPORT">Passaporte</ng-option>
                                    </ng-select>
                                    <div *ngIf="proposerFormControls['docType'].errors" class="invalid-feedback">
                                        <span *ngIf="proposerFormControls['docType'].errors">O Tipo de Documento é
                                            obrigatório</span>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label for="docNumberInput">N.º Documento</label>
                                    <input id="docNumberInput"
                                        [ngClass]="{ 'is-invalid': proposerFormControls['docNumber'].errors }"
                                        class="form-control" formControlName="docNumber" />
                                    <div *ngIf="proposerFormControls['docNumber'].errors" class="invalid-feedback">
                                        <span *ngIf="proposerFormControls['docNumber'].errors">O N.º Documento é
                                            obrigatório</span>
                                    </div>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label for="docExpirationInput">Validade</label>
                                    <input [ngClass]="{ 'is-invalid': proposerFormControls['docExpiration'].errors }"
                                        id="docExpirationInput" class="form-control" type="date"
                                        formControlName="docExpiration" />
                                    <div *ngIf="proposerFormControls['docExpiration'].errors" class="invalid-feedback">
                                        <span *ngIf="proposerFormControls['docExpiration'].errors">A Validade é
                                            obrigatória</span>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="maritalStatusSelect">Estado Civil</label>
                                    <ng-select id="maritalStatusSelect" formControlName="maritalStatus">
                                        <ng-option value="SINGLE">Solteiro(a)</ng-option>
                                        <ng-option value="MARRIED">Casado(a)</ng-option>
                                        <ng-option value="DIVORCED">Divorciado(a)</ng-option>
                                        <ng-option value="WIDOWED">Viúvo(a)</ng-option>
                                        <ng-option value="SEPARATED">Separado(a)</ng-option>
                                    </ng-select>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="propertyRegimeSelect">Regime de Bens</label>
                                    <ng-select id="propertyRegimeSelect" formControlName="propertyRegime">
                                        <ng-option value="COMMUNION_ACQUIRED">Adquiridos</ng-option>
                                        <ng-option value="COMMUNION_GENERAL">Geral</ng-option>
                                        <ng-option value="SEPARATION">Separação</ng-option>
                                    </ng-select>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="naturalnessInput">Naturalidade</label>
                                    <input id="naturalnessInput" class="form-control" formControlName="naturalness" />
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="nationalityInput">Nacionalidade</label>
                                    <input id="nationalityInput" class="form-control" formControlName="nationality" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Pessoa Coletiva -->
                <div class="accordion-item" *ngIf="isColetive()">
                    <h2 class="accordion-header" id="headingColetive">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseColetive" aria-expanded="false" aria-controls="collapseColetive">
                            Identificação
                        </button>
                    </h2>
                    <div id="collapseColetive" class="accordion-collapse collapse" aria-labelledby="headingColetive"
                        data-bs-parent="#proposerAccordion">
                        <div class="accordion-body">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <label for="companyInput">Empresa</label>
                                    <input id="companyInput"
                                        [ngClass]="{ 'is-invalid': proposerFormControls['company'].errors }"
                                        class="form-control" formControlName="company" />
                                    <div *ngIf="proposerFormControls['company'].errors" class="invalid-feedback">
                                        <span *ngIf="proposerFormControls['company'].errors">A Empresa é
                                            obrigatória</span>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="companyFiscalInput">NIPC</label>
                                    <input id="companyFiscalInput"
                                        [ngClass]="{ 'is-invalid': proposerFormControls['companyFiscalIdentification'].errors }"
                                        class="form-control" formControlName="companyFiscalIdentification" />
                                    <div *ngIf="proposerFormControls['companyFiscalIdentification'].errors"
                                        class="invalid-feedback">
                                        <span *ngIf="proposerFormControls['companyFiscalIdentification'].errors">O NIPC
                                            é
                                            obrigatório</span>
                                    </div>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label for="permanentRegistryInput">Certidão Permanente</label>
                                    <input id="permanentRegistryInput"
                                        [ngClass]="{ 'is-invalid': proposerFormControls['permanentRegistry'].errors }"
                                        class="form-control" formControlName="permanentRegistry" />
                                    <div *ngIf="proposerFormControls['permanentRegistry'].errors"
                                        class="invalid-feedback">
                                        <span *ngIf="proposerFormControls['permanentRegistry'].errors">O NIPC é
                                            obrigatório</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Contact and Address -->
                <div class="accordion-item" *ngIf="isSingular()">
                    <h2 class="accordion-header" id="headingContact">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseContact" aria-expanded="false" aria-controls="collapseContact">
                            Contactos e Morada
                        </button>
                    </h2>
                    <div id="collapseContact" class="accordion-collapse collapse" aria-labelledby="headingContact"
                        data-bs-parent="#proposerAccordion">
                        <div class="accordion-body row">
                            <div class="col-md-6 mb-3">
                                <label for="emailInput">Email</label>
                                <input id="emailInput" class="form-control" formControlName="email" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="phoneInput">Telefone</label>
                                <input id="phoneInput" class="form-control" formControlName="phone" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="addressInput">Morada Permanente</label>
                                <input id="addressInput" class="form-control" formControlName="address" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="cityInput">Cidade</label>
                                <input id="cityInput" class="form-control" formControlName="city" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="postalCodeInput">Código Postal</label>
                                <input id="postalCodeInput" class="form-control" formControlName="postalCode" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="countryInput">País</label>
                                <input id="countryInput" class="form-control" formControlName="country" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="fiscalAddressInput">Morada Fiscal</label>
                                <input id="fiscalAddressInput" class="form-control" formControlName="fiscalAddress" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="fiscalCityInput">Cidade Fiscal</label>
                                <input id="fiscalCityInput" class="form-control" formControlName="fiscalCity" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="fiscalPostalCodeInput">Código Postal Fiscal</label>
                                <input id="fiscalPostalCodeInput" class="form-control"
                                    formControlName="fiscalPostalCode" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="fiscalCountryInput">País Fiscal</label>
                                <input id="fiscalCountryInput" class="form-control" formControlName="fiscalCountry" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Occupation -->
                <div class="accordion-item" *ngIf="isSingular()">
                    <h2 class="accordion-header" id="headingOccupation">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOccupation" aria-expanded="false"
                            aria-controls="collapseOccupation">
                            Profissão
                        </button>
                    </h2>
                    <div id="collapseOccupation" class="accordion-collapse collapse" aria-labelledby="headingOccupation"
                        data-bs-parent="#proposerAccordion">
                        <div class="accordion-body row">
                            <div class="col-md-6 mb-3">
                                <label for="occupationInput">Profissão</label>
                                <input id="occupationInput" class="form-control" formControlName="occupation" />
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="employerInput">Entidade Empregadora</label>
                                <input id="employerInput" class="form-control" formControlName="employer" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Action -->
                <div class="accordion-item" *ngIf="isSingular()">
                    <h2 class="accordion-header" id="headingAction">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseAction" aria-expanded="false" aria-controls="collapseAction">
                            Atuação
                        </button>
                    </h2>
                    <div id="collapseAction" class="accordion-collapse collapse" aria-labelledby="headingAction"
                        data-bs-parent="#proposerAccordion">
                        <div class="accordion-body">
                            <label for="actionTypeSelect">Atua por conta de</label>
                            <ng-select id="actionTypeSelect" formControlName="actionType">
                                <ng-option value="SELF">Conta Própria</ng-option>
                                <ng-option value="OTHER">Conta de Outrem</ng-option>
                            </ng-select>
                            <div *ngIf="proposerForm.get('actionType')?.value === 'OTHER'" class="mt-3">
                                <label for="actionTypeOtherInput">Se outrem, especifique</label>
                                <input id="actionTypeOtherInput" class="form-control"
                                    formControlName="actionTypeOther" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Political Positions -->
                <div class="accordion-item" *ngIf="isSingular()">
                    <h2 class="accordion-header" id="headingPolitics">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapsePolitics" aria-expanded="false" aria-controls="collapsePolitics">
                            Cargos Políticos
                        </button>
                    </h2>
                    <div id="collapsePolitics" class="accordion-collapse collapse" aria-labelledby="headingPolitics"
                        data-bs-parent="#proposerAccordion">
                        <div class="accordion-body">
                            <div class="form-check mb-2">
                                <input type="checkbox" class="form-check-input" id="politicalPositionsCheck"
                                    formControlName="politicalPositions" />
                                <label class="form-check-label" for="politicalPositionsCheck">Exerceu cargos políticos
                                    nos últimos 12 meses?</label>
                            </div>
                            <div *ngIf="proposerForm.get('politicalPositions')?.value" class="mb-3">
                                <label for="politicalDescInput">Especifique</label>
                                <input id="politicalDescInput" class="form-control" formControlName="politicalDesc" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
            <button type="button" class="btn btn-primary" (click)="submitProposer(modal);">Guardar</button>
        </div>
    </form>
</ng-template>

<app-proposal-template *ngIf="showProposal" [isEdit]="isEdit" [proposal]="proposal" [deal]="deal"
    [entityData]="entityData" [leadId]="leadId" [proposalData]="proposalData"></app-proposal-template>
